import { Company } from "./company.model";

export class RegisterUser {
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  password: string;
  confirmPassword: string;
  company: Company;

  constructor() {
    this.company = new Company();
  }


}
